import { signIn } from 'next-auth/react';

const PROVIDER = 'agah';
type TUtmParams = Record<string, string | null>;

const extractUtmParams = (searchParams: URLSearchParams): TUtmParams => {
  const utmParams: TUtmParams = {};
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith('utm_')) {
      utmParams[key] = value;
    }
  }
  return utmParams;
};

const buildUtmQueryString = (utmParams: TUtmParams): string => {
  return Object.entries(utmParams)
    .filter(([, value]) => value && typeof value === 'string')
    .map(([key, value]) => `${key}=${encodeURIComponent(value!)}`)
    .join('&');
};

const encodeToUrlSafeBase64 = (input: string): string => {
  const bytes = new TextEncoder().encode(input);
  let base64 = btoa(String.fromCharCode(...bytes));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const getUtmFromUrl = (url: string): string => {
  if (url) {
    try {
      const decodedCallbackUrl = decodeURIComponent(url);
      const callbackSearchParams = new URLSearchParams(
        decodedCallbackUrl.includes('?') ? decodedCallbackUrl.split('?')[1] : decodedCallbackUrl
      );
      const utmParams = extractUtmParams(callbackSearchParams);
      const utmQueryString = buildUtmQueryString(utmParams);
      return utmQueryString;
    } catch (error) {
      console.warn('Failed to parse callbackUrl UTM params:', error);
    }
  }
  return '';
};

export const handleSignIn = (redirect: boolean = true, callbackUrl?: string) => {
  if (typeof window === 'undefined') {
    console.warn('handleSignIn called on server side');
    return Promise.resolve();
  }

  try {
    const currentUrl = callbackUrl || window.location.href;
    const utmQueryString = getUtmFromUrl(currentUrl);

    let customParams = undefined;

    if (utmQueryString) {
      const base64 = encodeToUrlSafeBase64(utmQueryString);
      customParams = { utm: base64 };
    }
    return signIn(
      PROVIDER,
      {
        redirect,
        callbackUrl: currentUrl,
      },
      customParams
    );
  } catch (error) {
    return signIn(PROVIDER, { redirect, callbackUrl: callbackUrl || window.location.href });
  }
};
